import {
  Datagrid,
  FunctionField,
  ListContextProvider,
  NumberField,
  SelectField,
  TextField,
  useRecordContext,
} from "react-admin";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { settings } from "app";
import { CurriculumItemTypeChoices } from "utils/choices";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import AddModuleItemsDialog from "./Dialogs/AddModuleItemsDialog";
import UpdateItemDialog from "./Dialogs/UpdateItemDialog";
import RemoveDialog from "./Dialogs/RemoveDialog";
import AddModulesDialog from "./Dialogs/AddModulesDialog";
import RenameModuleDialog from "./Dialogs/RenameModuleDialog";
import { SectionTitle } from "features/SectionTitle";

const ModulesSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const record = useRecordContext();

  if (!record?.modules?.length) return null;

  return (
    <>
      <SectionTitle
        title="Модули"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          sx={{ display: "flex", flexDirection: "column", gap: 2 }}
        >
          {record.modules.map((module, index) => (
            <Box
              key={module.id}
              sx={{ display: "flex", gap: 2, alignItems: "center" }}
            >
              <Accordion sx={{ width: "80%" }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={2}
                  >
                    <Box
                      sx={{
                        width: 36,
                        height: 36,
                        borderRadius: "50%",
                        backgroundColor: "primary.main",
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 14,
                        flexShrink: 0,
                      }}
                    >
                      {index + 1}
                    </Box>
                    <Typography
                      fontWeight="bold"
                      fontSize={16}
                      color="primary"
                    >
                      {module.nameBg}
                    </Typography>
                    {module.nameEn && (
                      <Typography
                        fontSize={14}
                        color="text.secondary"
                      >
                        / {module.nameEn}
                      </Typography>
                    )}
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <ListContextProvider value={{ data: module.items || [] }}>
                    <Typography sx={{ color: "#361B5C", fontWeight: 600, fontSize: 12 }}>Теми</Typography>
                    <Datagrid
                      bulkActionButtons={false}
                      rowClick={false}
                      sx={settings.style.secondaryLeftAlignedDatagrid}
                    >
                      <TextField
                        source="nameBg"
                        label="Наименование (БГ)"
                        sortable={false}
                      />
                      <TextField
                        source="nameEn"
                        label="Наименование (EN)"
                        sortable={false}
                      />
                      <SelectField
                        source="type"
                        label="Тип"
                        choices={CurriculumItemTypeChoices}
                        sortable={false}
                      />
                      <NumberField
                        source="durationHours"
                        label="Часове"
                        sortable={false}
                        emptyText="-"
                        textAlign="left"
                      />
                      <FunctionField
                        render={rec => (
                          <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
                            <SecuredComponent permission={permissions.canManageSpecializationsCurricula}>
                              <UpdateItemDialog
                                curriculumId={record?.id}
                                itemId={rec?.id}
                                moduleId={module?.id}
                              />
                            </SecuredComponent>
                            <SecuredComponent permission={permissions.canManageSpecializationsCurricula}>
                              <RemoveDialog
                                curriculumId={record?.id}
                                id={rec?.id}
                                type="items"
                                label="тема"
                              />
                            </SecuredComponent>
                          </Box>
                        )}
                      />
                    </Datagrid>
                  </ListContextProvider>
                  <SecuredComponent permission={permissions.canManageSpecializationsCurricula}>
                    <AddModuleItemsDialog
                      curriculumId={record?.id}
                      moduleId={module.id}
                    />
                  </SecuredComponent>
                </AccordionDetails>
              </Accordion>
              <Box sx={{ width: "20%" }}>
                <SecuredComponent permission={permissions.canManageSpecializationsCurricula}>
                  <RenameModuleDialog
                    curriculumId={record?.id}
                    module={module}
                  />
                </SecuredComponent>
              </Box>
            </Box>
          ))}
          <Box sx={{ width: "20%" }}>
            <SecuredComponent permission={permissions.canManageSpecializationsCurricula}>
              <AddModulesDialog curriculumId={record?.id} />
            </SecuredComponent>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default ModulesSection;
